import axios from 'axios';
import _ from 'lodash';
import { createUserQuery } from './queries';
import { fetchRegionFromBackend } from '../../utils/regionConfig';

const addUser = async (model) => {
    try {
        // Fetch the correct region from the backend before creating the user
        // This ensures dev/staging environments use the correct region (e.g., UDA)
        // instead of the dev environment name (e.g., TLEWIS-MM)
        const region = await fetchRegionFromBackend();

        const userModel = _.omit(model, 'password_confirmation');
        // coerce username to lowercase on both login + signup
        userModel.username = userModel.username.toLowerCase();
        // Set the region from the backend
        userModel.region = region;

        const query = createUserQuery({ model: userModel });
        const response = await axios.post(query.url, { ...query.body });

        return { data: response.data };
    } catch (error) {
        const message = error?.response?.data?.error;
        if (message) {
            throw message;
        }
        throw error;
    }
};

export default addUser;
